import React, { useState, useEffect } from 'react';
import api from '../api/axios';

const EditVendorProfileModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    legalEntityName: '',
    shopName: '',
    contactPerson: '',
    email: '',
    phone: '',
    registeredAddress: '',
    gstin: ''
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      api.get('/vendors/me')
        .then(res => {
          if (res.data.success && res.data.data) {
            const d = res.data.data;
            setFormData({
              legalEntityName: d.legalEntityName || '',
              shopName: d.shopName || '',
              contactPerson: d.contactPerson || '',
              email: d.email || '',
              phone: d.phone || '',
              registeredAddress: d.registeredAddress || '',
              gstin: d.gstin || ''
            });
          }
        })
        .catch(err => console.error(err));
    }
  }, [isOpen]);

  const handleChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.put('/vendors/me', formData);
      if (res.data.success) {
        alert('Profile updated successfully!');
        onClose();
        // optionally refresh dashboard data here
        window.location.reload();
      }
    } catch (err) {
      alert(err.response?.data?.message || 'Error updating profile');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className='fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4'>
      <div className='bg-[#111] border border-[#E8B84B]/30 rounded-2xl w-full max-w-md p-6'>
        <h2 className='text-[#E8B84B] text-xl font-bold mb-4 flex items-center gap-2'>
          <span className="material-symbols-outlined">edit</span> Edit Vendor Profile
        </h2>
        <form onSubmit={handleSubmit} className='space-y-4'>
          <div>
            <label className='block text-xs text-stone-400 mb-1 font-bold'>Legal Name / Entity</label>
            <input 
              name='legalEntityName' 
              value={formData.legalEntityName} 
              onChange={handleChange} 
              required 
              className='w-full bg-[#1a1a1a] border border-[#333] rounded px-3 py-2 text-sm text-white focus:border-[#E8B84B] outline-none' 
            />
          </div>
          <div>
            <label className='block text-xs text-stone-400 mb-1 font-bold'>Shop Name</label>
            <input 
              name='shopName' 
              value={formData.shopName} 
              onChange={handleChange} 
              required 
              className='w-full bg-[#1a1a1a] border border-[#333] rounded px-3 py-2 text-sm text-white focus:border-[#E8B84B] outline-none' 
            />
          </div>
          <div>
            <label className='block text-xs text-stone-400 mb-1 font-bold'>Contact Person</label>
            <input 
              name='contactPerson' 
              value={formData.contactPerson} 
              onChange={handleChange} 
              required 
              className='w-full bg-[#1a1a1a] border border-[#333] rounded px-3 py-2 text-sm text-white focus:border-[#E8B84B] outline-none' 
            />
          </div>
          <div>
            <label className='block text-xs text-stone-400 mb-1 font-bold'>Email</label>
            <input 
              name='email' 
              type='email' 
              value={formData.email} 
              onChange={handleChange} 
              required 
              className='w-full bg-[#1a1a1a] border border-[#333] rounded px-3 py-2 text-sm text-white focus:border-[#E8B84B] outline-none' 
            />
          </div>
          <div>
            <label className='block text-xs text-stone-400 mb-1 font-bold'>Phone Number</label>
            <input 
              name='phone' 
              value={formData.phone} 
              onChange={handleChange} 
              required 
              className='w-full bg-[#1a1a1a] border border-[#333] rounded px-3 py-2 text-sm text-white focus:border-[#E8B84B] outline-none' 
            />
          </div>
          <div>
            <label className='block text-xs text-stone-400 mb-1 font-bold'>Pickup Address</label>
            <textarea 
              name='registeredAddress' 
              value={formData.registeredAddress} 
              onChange={handleChange} 
              required 
              rows={2}
              className='w-full bg-[#1a1a1a] border border-[#333] rounded px-3 py-2 text-sm text-white focus:border-[#E8B84B] outline-none resize-none' 
            />
          </div>
          <div>
            <label className='block text-xs text-stone-400 mb-1 font-bold'>GST Number</label>
            <input 
              name='gstin' 
              value={formData.gstin} 
              onChange={handleChange} 
              className='w-full bg-[#1a1a1a] border border-[#333] rounded px-3 py-2 text-sm text-white focus:border-[#E8B84B] outline-none uppercase' 
              placeholder='Optional'
            />
          </div>
          <div className='flex gap-3 justify-end mt-6 pt-4 border-t border-[#222]'>
            <button 
              type='button' 
              onClick={onClose} 
              className='px-4 py-2 text-sm font-bold text-stone-400 hover:text-white transition-colors'
            >
              Cancel
            </button>
            <button 
              type='submit' 
              disabled={loading} 
              className='px-5 py-2 text-sm bg-[#E8B84B] text-black font-bold rounded-lg hover:bg-[#B8923A] transition-colors shadow-lg'
            >
              {loading ? 'Saving...' : 'Save Profile'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditVendorProfileModal;
